import { useContext, useEffect, useMemo, useState } from 'react'
import { LayoutContext } from '../contexts'

export const useFormatPrice = () => {
  const { currency: localCurrency, node_locale } = useContext(LayoutContext)

  const [currencySymbol, setCurrencySymbol] = useState('')

  const showSymbolRight = useMemo(
    () => node_locale === 'de' || node_locale === 'fr',
    [node_locale],
  )
  const isEurope = useMemo(() => node_locale !== 'en-US', [node_locale])
  const isUK = useMemo(() => node_locale === 'en-GB', [node_locale])

  const formatPrice = (money) => {
    const moneyWithDecimals = money.toFixed(2)
    const moneySeparated =
      isEurope && !isUK
        ? moneyWithDecimals.replace('.', ',')
        : moneyWithDecimals

    return showSymbolRight
      ? `${moneySeparated} ${currencySymbol}`
      : `${currencySymbol}${moneySeparated}`
  }

  useEffect(() => {
    if (localCurrency) {
      setCurrencySymbol(localCurrency.symbol)
    }
  }, [localCurrency])

  return formatPrice
}
